export default __webpack_public_path__ + "static/healthcare-page-step-3-d2b8e625328eff1fd475b04354094f6c.svg";